<template>
	<div>
		<v-dialog
			v-model="open"
			:adaptive="true"
			width="500"
			@input="$emit('input', $event)"
		>
			<v-card>
				<v-progress-linear v-if="loading" indeterminate></v-progress-linear>
				<v-layout>
					<v-spacer />
					<v-btn small icon @click="$emit('input', false)">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-layout>
				<v-list>
					<v-list-item width="auto">
						<v-list-item-title width="50">Job</v-list-item-title>
						<v-list-item-title>Desc</v-list-item-title>
					</v-list-item>
					<v-divider />
					<v-divider />

					<div v-for="(job, index) in jobs" :key="index">
						<v-list-item
							v-if="job.key != jobCode"
							@click="$emit('click', job.key)"
						>
							<v-list-item-title>{{ job.key }}</v-list-item-title>
							<v-list-item-subtitle width="auto" style="white-space: pre">
								<pre style="white-space: pre-line;"> {{ job.value }} </pre>
							</v-list-item-subtitle>
						</v-list-item>

						<v-list-item
							v-else
							@click="$emit('click', job.key)"
							dark
							color="success"
							:style="'background-color:' + $vuetify.theme.themes.light.primary"
						>
							<v-list-item-title>{{ job.key }}</v-list-item-title>
							<v-list-item-subtitle>{{ job.value }}</v-list-item-subtitle>
						</v-list-item>
						<v-divider />
					</div>
				</v-list>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import jobStageService from "../../services/jobStageService";
	export default {
		name: "resource-jobs-dialog",
		props: ["value", "resourceId", "jobCode", "jobDescription"],
		data() {
			return {
				open: false,
				jobs: [],
				loading: false,
				alert: { alerts: [], type: "error" },
			};
		},
		watch: {
			async value(val) {
				this.open = val;
				if (val == true) {
					this.jobs = [];
					await this.getJobs();
				}
			},
		},
		methods: {
			async getJobs() {
				if (!this.resourceId) return;
				let res = await jobStageService.getJobsInResourceByResourceId(
					this.resourceId
				);
				if (res.success) {
					this.jobs = res.data;
				} else {
					this.alert.alerts = res.data;
				}
			},
		},
		async mounted() {
			this.open = this.value;
			await this.getJobs();
		},
	};
</script>

<style></style>
